<template>
    <div class="td-autocomplete form-item">
        <div v-if="!hideLabel">
            <label for="location">Locations: </label>
        </div>
        <div :class="[searchTermLocation ? 'focused': '', 'autocomplete-input']">
            <input type="text"
                   autocomplete="off"
                   placeholder="Select locations from the list"
                   name="location"
                   id="location"
                   @focus="showLocationList = true"
                   v-model="searchTermLocation"
                   @keyup.enter="selectLocation(locationList[0])"
                   :class="{ error: isError}" />
        </div>
        <div></div>
        <div :class="[showLocationList ? 'show-results' : 'hide-results', 'autocomplete-results']">
            <ul class="results-list" v-if="locationList.length > 0">
                <li v-for="(item, idx) in locationList" :key="idx">
                    <a @click.prevent="selectLocation(item)" href="#">{{item.display}}</a>
                </li>
            </ul>
            <ul class="results-list" v-else>
                <li class="td-text-subdued pa-1">
                    No locations found
                </li>
            </ul>
            <icon @click="showLocationList = false" name="faXmark" type="solid" class="td-text-danger close-list"></icon>
        </div>
    </div>
</template>
<script>
    import script from './LocationLookup';
    export default script;</script>
<style lang="less">
    @import './LocationLookup.less';
</style>